import { FormEvent, useContext, useRef, useState } from "react"
import { FaFileImage } from "react-icons/fa"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { criptografarDado } from "../../helpers"
import { conquistaParams } from "../../interfaces/conquista"
import { atualizarConquista, novaConquista } from "../../services/conquistas"
import { Button, Loader } from "../Styles"
import "./index.css"

function ModalConquista({ conquista }: conquistaParams) {

    const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

    const [titulo, setTitulo] = useState(conquista?.titulo || "")
    const [descricao, setDescricao] = useState(conquista?.descricao || "")

    const [imagem, setImagem] = useState<string | null>(conquista?.avatar || null)
    const [imagemArquivo, setImagemArquivo] = useState<File | null>(null)

    const fileInputRef = useRef<HTMLInputElement>(null)

    const [situacao, setSituacao] = useState(conquista?.situacao)
    const [processando, setProcessando] = useState(false)

    const onSubmit = async (e: FormEvent) => {
        
        e.preventDefault()
        setProcessando(true)

        try {

            const formData = new FormData()

            formData.append("titulo", titulo)
            formData.append("descricao", descricao)

            if (imagemArquivo) {
                formData.append("file", imagemArquivo)
            }

            const resposta = await novaConquista(formData)

            if (resposta.status === 201) {
                atualizarDados()
                modalExibir("")
                toast.success("Conquista cadastrada com Sucesso.")
            }
        } catch {
            toast.error("Erro ao cadastrar Conquista")
        } finally {
            setProcessando(false)
        }
    }

    const onUpdate = async (e: FormEvent) => {

        e.preventDefault()
        if (!conquista) return toast.error("Conquista não encontrada.")
        try {
            setProcessando(true)

            const formData = new FormData()

            formData.append("titulo", titulo)
            formData.append("descricao", descricao)

            if (imagemArquivo) {
                formData.append("file", imagemArquivo)
            }

            if (situacao) {
                formData.append("situacao", situacao)
            }
            const resposta = await atualizarConquista(criptografarDado(conquista.id.toString()), formData)

            if (resposta.status === 200) {
                atualizarDados()
                modalExibir("")
                toast.success("Conquista atualizada com Sucesso.")
            }
        } catch {
            toast.error("Erro ao atualizar Conquista")
        } finally {
            setProcessando(false)
        }
    }

    const handleImagemChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const file = e.target.files?.[0]

        if (file) {
            setImagemArquivo(file)
            setImagem(URL.createObjectURL(file))
        }
    }

    const acionarInputFile = () => {
        fileInputRef.current?.click()
    }

    return (
        <div className="fundoModal">
            <section className={conquista ? 'containerModal' : 'containerModalCentro'}>
                <span id='novoContainerTitulo'>
                    <p>{!conquista ? 'Cadastrar Conquista' : 'Atualizar Conquista'}</p>
                </span>
                <form id='formModalNovo' onSubmit={conquista ? onUpdate : onSubmit}>
                    <span className="avatarUploadContainer">
                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            onChange={handleImagemChange}
                            style={{ display: 'none' }}
                        />

                        <div className="avatarCirculo" onClick={acionarInputFile}>
                            {imagem ? (
                                <img src={imagem} alt="Preview da conquista" className="avatarImagem" />
                            ) : (
                                <FaFileImage className="avatarIconePlaceholder" size={40} />
                            )}
                        </div>

                        <button type="button" className="btnAlterarImagem" onClick={acionarInputFile}>
                            Alterar imagem
                        </button>
                    </span>
                    <section>
                        <span>
                            <label>Título</label>
                            <input type="text" placeholder="Titulo" onChange={(e) => setTitulo(e.target.value)} required={!conquista} defaultValue={conquista?.titulo} />
                        </span>
                    </section>

                    <section>
                        <span>
                            <label>Descrição</label>
                            <textarea className="textAreaModal" rows={5} placeholder="Descrição" onChange={(e) => setDescricao(e.target.value)} defaultValue={conquista?.descricao} required></textarea>
                        </span>
                    </section>

                    {conquista && <section>
                        <span>
                            <label htmlFor="situacaoCento">Situacao</label>
                            <select id="situacaoCento" value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                                <option value="Ativa">Ativa</option>
                                <option value="Inativa">Inativa</option>
                            </select>
                        </span>
                    </section>
                    }

                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir("")}>Fechar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                            {!processando && !conquista && 'Cadastrar'}
                            {!processando && conquista && 'Atualizar'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalConquista